import { indexOf } from 'lodash';
import { ELanguage } from 'projects/ng-util/src/lib/i18n/enums/language.enum';

export class Language {
  public readonly name: string;
  public readonly id: number;
  public static readonly Portuguese = new Language('pt-BR');
  public static readonly English = new Language('en-US');
  public static readonly Spanish = new Language('es-ES');

  public static get availables() { return Object.values(ELanguage); }

  constructor(languageCode: string);
  constructor(id: ELanguage | number);
  constructor(arg: ELanguage | string | number) {

    if (arg in ELanguage) {
      this.id = ELanguage[arg];
    } else if (typeof (arg) === 'string') {
      this.id = indexOf(Language.availables, arg);
    } else if (arg in Array.from(Object.values(ELanguage))) {
      this.id = arg;
    }

    if (!(this.id in Language.availables)) throw new Error('O idioma informado não corresponde com os idiomas disponíveis');

    this.name = Language.availables[this.id];
  }
}
